// @flow

import partition from 'lodash.partition';
import memoize from 'lodash.memoize';

import type {RowData} from '../typedef';

type PrepareSplitByTopTableRowsType<DataRow> = {|
    topTableRows: Array<RowData<DataRow>>,
    ordinaryRows: Array<RowData<DataRow>>,
|};

const prepareSplitByTopTableRows = <DataRow>(
    rows: Array<RowData<DataRow>>
): PrepareSplitByTopTableRowsType<DataRow> => {
    const [topTableRows, ordinaryRows] = partition(rows, {topTableRow: true});
    return {topTableRows, ordinaryRows};
};

export const splitByTopTableRows: <DataRow>(rows: Array<RowData<DataRow>>) => PrepareSplitByTopTableRowsType<DataRow> =
    memoize<Array<Array<RowData<Object>>>, PrepareSplitByTopTableRowsType<Object>>(prepareSplitByTopTableRows);

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("../typedef");
